import { SynonymMap } from '../models/searchable-item.model';

/**
 * Expand each query token by every synonym + related term from the
 * concept whose `terms` list contains it. Returns the union of:
 *  - original tokens
 *  - all `terms` of any matching concept
 *  - all `related` terms of any matching concept
 *
 * Cheap O(tokens × concepts) walk — synonyms.<lang>.json has ~100–200
 * concepts so this is fine on the hot path.
 */
export function expandSemantic(
  tokens: ReadonlyArray<string>,
  synonyms: SynonymMap
): Set<string> {
  const expanded = new Set<string>(tokens);
  for (const tok of tokens) {
    for (const concept of Object.values(synonyms)) {
      if (concept.terms.some((t) => t === tok || t.includes(tok))) {
        for (const t of concept.terms) expanded.add(t);
        for (const r of concept.related) expanded.add(r);
      }
    }
  }
  return expanded;
}
